import * as R from 'ramda'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { createSearchAction, getSearchSelectors } from 'redux-search'
import { List, ListItem } from 'material-ui/List'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card'
import Badge from 'material-ui/Badge'

import LeftNavMenu from 'components/LeftNavMenu'
import Back from 'components/Back'
import NotificationCard from 'components/NotificationCard'
import TableSearch from './TableSearch'
import Search from 'components/Search'

import notifications from 'actions/notifications'
import sessionActions from 'actions/sessionActions'
import navigationActions from 'actions/navigation'
import { currentUserNotifications, currentUserOpenNotifications } from 'selectors/notifications'
import { managers } from 'selectors/entities'
import { currentUser } from 'selectors/common'
import { allTable } from 'selectors/globalSearch'
import { selector as resourceSelector } from 'selectors/search'
import * as allEntities from 'selectors/entities'
import filters from 'selectors/filters'

global.filters = filters

let select = (state, props) => {
	let { text } = getSearchSelectors({
		resourceName: 'all'
	  , resourceSelector: resourceSelector
	})
	return ({
		filters: R.map(R.map(selector => selector(state)), filters)
	  , currentUserOpenNotifications: currentUserOpenNotifications(state)
	  , managers: managers(state)
	  , currentUserID: currentUser(state)
	  , searchResault: allTable(state)
	  , text: text(state)
	})
}

const contents = [
	['notification']
  , ['project', 'property', 'transaction', 'task']
  , ['repairman', 'agent', 'owner', 'template', 'managers', 'tenants']
]

const display = {
	'For Rent': true
  , 'Not in Service': true
  , 'Open Projects': true
  , 'Unpaid Bills': true
  , 'Unpaid Invoices': true
  , 'Open Tasks': true
}

const titles = {
	'property': 'Properties'
  , 'project': 'Projects'
  , 'transaction': 'Transactions'
  , 'task': 'Tasks'
  , 'repairman': 'Repairmen'
  , 'agent': 'Agents'
  , 'owner': 'Owners'
  , 'template': 'Templates'
  , 'managers': 'Managers'
  , 'tenants': 'Tenants'
  , 'notification': 'Notifications'
}

const colors = {
	'For Rent': '#BA68C8'
  , 'Not in Service': '#000'
  , 'Occupied': '#39cea8'
  , 'Retired': '#A0A0A0'
  , 'Closed Projects': '#3cd2ae'
  , 'Open Projects': '#000'
  , 'Bills': '#FF0000'
  , 'Paid Bills': '#FF0000'
  , 'Unpaid Bills': '#FF0000'
  , 'Invoices': '#39cea8'
  , 'Paid Invoices': '#39cea8'
  , 'Unpaid Invoices': '#39cea8'
}

export class Dashboard extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render () {
		let {props} = this
		return (
			<div style={{margin: "0", padding: "0"}}>
				<div style={{
						position: "fixed"
					  , top: "0px"
					  , left: "0px"
					  , bottom: "0px"
					  , backgroundColor: "rgb(41, 48, 56)"
					  , textAlign: "left"
					  , paddingTop: "60px"
					  , zIndex:"300"
				}}>
					<LeftNavMenu style={{width: "60px"}} route={"dashboard"} />
				</div>
				<div style={{
						position: "fixed"
					  , left: "0px"
					  , top: "0px"
					  , right: "0px"
					  , height: "60px"
					  , backgroundColor: "#3cd2ae"
					  , textAlign: "left"
					  , zIndex:"301"
				}}>
					<div style={{display: "inline-block", float: "left", height: "60px", overflow: "hidden"}}>
						<Back />
					</div>
					<div style={{
							float: "left"
						  , position: "relative"
						  , top: "17px"
						  , left: "40px"}}
					>
						<Search entity={'all'} id="search-properties" style={{marginTop: "-8px"}}/><
					/div>
					<div style={{float:"right", paddingRight:"10px", display:"inline-block"}}>
						<span style={{lineHeight:"50px", fontSize:"18px", float:"left", color: "white", cursor: "pointer"}} onClick={()=>{this.toggleMenu()}}>
							{props.managers[props.currentUserID] && (props.managers[props.currentUserID].name || "") }
						</span>
						<IconMenu
							iconButtonElement={<IconButton style={{padding:"0", height:"40px", width:"40px", top:"5px"}}><MoreVertIcon color= "white"/></IconButton>}
							anchorOrigin={{horizontal: 'left', vertical: 'top'}}
							targetOrigin={{horizontal: 'left', vertical: 'top'}}
							open={this.state.isOpen}
							onRequestChange={this.toggleMenu}
							onItemTouchTap={(event, obj)=>{obj.props.act()}}
							style={{
								verticalAlign: "middle"
							  , padding:"0"
							}}
						>
							<MenuItem
								value="Log out"
								primaryText="Log out"
								act={props.LOGOUT}
							/>
						</IconMenu>
					</div>
				</div>
				{!props.text ? contents.map((entities, idx) =>
					<div style={{width: "calc(100%-60px)", margin: "60px 0 0 60px", position: "relative", zIndex: "-3000"}} key={idx+1}>
						<List
							className={`dashboard-${idx + 1}`}
							style={{
								minWidth: "380px"
							  , width: window.innerWidth > 1300 ? "calc(33% - 4px)":
									   window.innerWidth < 1300 && window.innerWidth > 1050 ?"calc(50% - 8px)":
									   "calc(100% - 8px)"
							  , float: "left"
								, margin: "4px"
								, boxShadow: "0 0 5px rgba(0,0,0,0.5)"
							}}
						>
							{entities.map((entityName) =>
								{return entityName == 'notification'?
									<Card
										key={entityName}
										initiallyExpanded={true}
										style={{backgroundColor: "#F5F5F5", border: "0px", boxShadow: "none", marginTop: "-2px"}}
									>
										<CardHeader
										  title={
											  <div>
												  <span style={{float: "left"}}>Notifications</span>
												  <Badge
													   badgeContent={props.currentUserOpenNotifications.length}
													   style={{marginTop: "-4px"}}
													   badgeStyle={{backgroundColor: '#009688', color:"white"}}
												  />
											  </div>
										  }
										  showExpandableButton={true}
										/>
										<CardText expandable={true}>
											<List>
												{props.currentUserOpenNotifications.length ?
													R.map(notification =>
														<NotificationCard
															notificationID={notification._id}
															key={notification._id}
														/>
													  , R.reverse(R.sortBy(R.prop('createdAt'), R.values(props.currentUserOpenNotifications)))
													)
													:
													<ListItem style={{marginTop: "-16px"}}>All done</ListItem>
												}
											</List>
										</CardText>
									</Card>
									:
									<ListItem
										key={entityName}
										initiallyOpen={true}
										onNestedListToggle={(toggle) => console.log(`${entityName} toggle: `, toggle)}
										primaryText={<div
												style={{
													width: "calc(100% - 16px)"
												  , height: "48px"
												  , marginTop: "-16px"
												  , marginLeft: "-16px"
												  , marginBottom: "-16px"
												}}
												onClick={(x)=>{props.NAVIGATION({entity: entityName})}}
											>
												<div style={{position: "relative", top: "16px",left: "16px"}}>
													<b>{titles[entityName]}</b>
												</div>
											</div>}
										autoGenerateNestedIndicator={true}
										nestedItems={R.values(
											R.mapObjIndexed(
												(filteredList, filterName) => {
													if (display[filterName]) return(
														<ListItem
															style={{height: "48px"}}
															key={filterName}
															primaryText={
																<div>
																	<span style={{float: "left"}}>{filterName}</span>
																	<Badge
																		 badgeContent={Object.keys(filteredList).length}
																		 style={{marginTop: "-4px"}}
																		 badgeStyle={{backgroundColor: colors[filterName] || '#009688', color:"white"}}
																	/>
																</div>
															}
															onClick={(x)=>{props.OPEN_PREFILTERED({entity: entityName, predefined: filterName})}}
														/>
													)
												}
											  , props.filters[entityName] || {}
											)
										)}
									/>
								}
							)}
						</List>
					</div>
				)
				:<div style={{margin:"60px 0 0 0", overflowX:"hidden", overflowY:"auto", boxSizing:"border-box"}}>
					<div style={{position:"relative", paddingLeft:"55px", boxSizing:"border-box"}}>
						<TableSearch />
					</div>
				</div>
				}
			</div>
		)
	}
}

export default connect(select, {...navigationActions, ...sessionActions})(Dashboard)



// WEBPACK FOOTER //
// ./src/routes/manager/dashboard/index.js